import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter, Route } from 'react-router-dom';
import '@amzn/awsui-global-styles/polaris.css';

ReactDOM.render(
  <BrowserRouter>
    <React.StrictMode>
      <Route component={App} />
    </React.StrictMode>
  </BrowserRouter>,
  document.getElementById('app'),
);
